import React from 'react';
import {Header, Segment, Form, Loader, Table, Button, Icon, Message, Checkbox, Divider, Popup} from 'semantic-ui-react';
import Modal from 'react-responsive-modal';
import axios from 'axios';
import { fetchFacultiesOnly, fetchAcademicYears, fetchAllAcademicYears } from '../../Lookups/util';
import { toast, ToastContainer } from 'react-toastify';
import PaginationFront from '../../util/PaginationFront';
import SearchTableData from '../../util/SearchTableData';
import enrolledStudents from "../../StudentService/StudentsReports/EnrolledStudents";

axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;

export default class OnlineEnrollment extends React.Component {
    constructor(props) {
        super(props);

        let storedorganizationalUnitId = '';
        if (localStorage.getItem('organizationalUnitId')) {
            storedorganizationalUnitId = parseInt(localStorage.getItem('organizationalUnitId'), 10);
        }

        this.state = {
            students: [],
            orgUnits: [],
            academicYears: [],
            studyPrograms: [],
            validatedStudyPrograms: [],

            organizationalUnitId: storedorganizationalUnitId,
            year: '',
            cycle: '',
            enrollmentCallOrdinal: '',

            results: [],
            searched: false,
            selectedStudents: [],
            selectedTransferredStudents: [],
            changedTransferredStudents: [],
            prebacenEditMode: false,
            open: false,

            loading: false,
            saving: false,
            loadedYears: false,

            enrolling: false,
            enrollFinished: false,
            enrollmentFailedStudents: [],

            activePage: 1,
            postsPerPage: 20,
            enrollmentResult: null,
        };

        this.handleInputChange = this.handleInputChange.bind(this);
        this.fetchStudents = this.fetchStudents.bind(this);
        this.handleSearchClick = this.handleSearchClick.bind(this);
        this.getDataToRender = this.getDataToRender.bind(this);
        this.getResults = this.getResults.bind(this);
        this.handleStudentCheck = this.handleStudentCheck.bind(this);
        this.handleSelectAllCurrent = this.handleSelectAllCurrent.bind(this);
        this.handleSelectAllTransferred = this.handleSelectAllTransferred.bind(this);
        this.isStudentChecked = this.isStudentChecked.bind(this);
        this.toggleTransferredStudent = this.toggleTransferredStudent.bind(this);
        this.handleSaveTransferred = this.handleSaveTransferred.bind(this);
        this.handleCancelTransferredEdit = this.handleCancelTransferredEdit.bind(this);
        this.isTransferredStudentChecked = this.isTransferredStudentChecked.bind(this);
        this.enrollStudents = this.enrollStudents.bind(this);
        this.getSelectedStudyPrograms = this.getSelectedStudyPrograms.bind(this);
        this.fetchStudyProgramsByOrgUnit = this.fetchStudyProgramsByOrgUnit.bind(this);
        this.handleCloseModal = this.handleCloseModal.bind(this);
        this.removeStudentsWithMissingStudyProgram = this.removeStudentsWithMissingStudyProgram.bind(this);
        this.openEnrollmentModal = this.openEnrollmentModal.bind(this);
    }

    componentDidMount() {
        axios.all([
            fetchFacultiesOnly(),
            fetchAllAcademicYears()
        ])
            .then(axios.spread((orgUnitsRes, yearsRes) => {
                const orgUnits = orgUnitsRes.data.map(el => ({
                    ...el,
                    key: el.id,
                    value: el.id,
                    text: el.name
                }));

                const academicYears = yearsRes.data.reverse().map(el => ({
                    ...el,
                    value: el.startYear,
                    key: el.startYear,
                    text: el.name
                }));

                this.setState({
                    orgUnits,
                    academicYears,
                    loadedYears: true
                }, () => {
                    if (this.state.organizationalUnitId) {
                        this.fetchStudyProgramsByOrgUnit(this.state.organizationalUnitId);
                    }
                });
            }))
            .catch((err) => {
                console.log('Failed to fetch initial data. ', err);
                this.setState({ error: true });
            });
    }

    fetchStudyProgramsByOrgUnit(organizationalUnitId) {
        if (!organizationalUnitId) {
            this.setState({ studyPrograms: [] });
            return;
        }

        axios.get(`/study-programs/filter/${organizationalUnitId}`)
            .then((res) => {
                const studyPrograms = res.data.map(el => ({
                    ...el,
                    value: el.id,
                    key: el.id,
                    text: el.studyProgramBasicName
                        ? el.studyProgramBasicName + ' (' + el.name + ')'
                        : el.name
                }));

                this.setState({ studyPrograms });
            })
            .catch((err) => {
                console.log('Failed to fetch study programs. ', err);
                this.setState({ studyPrograms: [] });
            });
    }

    fetchStudents() {
        this.setState({
            loading: true,
            results: [],
            activePage: 1,
            searched: true,
            selectedStudents: []
        });

        const { organizationalUnitId, year, cycle, enrollmentCallOrdinal } = this.state;

        axios.get(`/enrollments/students-for-enrollment/${organizationalUnitId}/${year}/${cycle}/${enrollmentCallOrdinal}`)
            .then((res) => {
                this.setState({
                    students: res.data || [],
                    loading: false,
                    prebacenEditMode: false,
                    selectedTransferredStudents: [],
                    changedTransferredStudents: []
                });
            })
            .catch(() => {
                this.setState({
                    students: [],
                    loading: false,
                    prebacenEditMode: false,
                    selectedTransferredStudents: [],
                    changedTransferredStudents: []
                });
                toast('Došlo je do greške. Nije moguće učitati studente.');
            });
    }

    enrollStudents() {
        const { organizationalUnitId, year, cycle, enrollmentCallOrdinal, selectedStudents } = this.state;
        const enrolledStudents = selectedStudents;

        this.setState({
            enrolling: true,
            enrollFinished: false,
            enrollmentFailedStudents: [],
            enrollmentResult: null
        });

        axios.post(
            `/enrollments/enroll/${organizationalUnitId}/${year}/${cycle}/${enrollmentCallOrdinal}`,
            enrolledStudents
        )
            .then((res) => {
                this.setState({
                    enrolling: false,
                    enrollFinished: true,
                    enrollmentResult: res.data || null
                });

                if (res.data && res.data.success > 0 && (!res.data.failedStudents || res.data.failedStudents.length === 0)) {
                    toast('Brucoši su uspješno upisani.');
                }
            })
            .catch(() => {
                this.setState({
                    enrolling: false,
                    enrollFinished: true,
                    enrollmentResult: null
                });
                toast('Došlo je do greške. Nije moguće upisati brucoše.');
            });
    }

    handleSearchClick() {
        const { organizationalUnitId, year, cycle, enrollmentCallOrdinal } = this.state;

        if (!organizationalUnitId || !year || !cycle || !enrollmentCallOrdinal) {
            toast('Morate odabrati organizacionu jedinicu, akademsku godinu, ciklus i upisni rok.');
            return;
        }

        localStorage.setItem('organizationalUnitId', organizationalUnitId);
        this.fetchStudents();
    }

    handleInputChange(event, { name, value }) {
        this.setState({
            [name]: value,
            activePage: 1,
            results: [],
            searched: false,
            students: [],
            selectedStudents: [],
            selectedTransferredStudents: [],
            changedTransferredStudents: [],
            prebacenEditMode: false
        }, () => {
            if (name === 'organizationalUnitId') {
                this.fetchStudyProgramsByOrgUnit(value);
            }
        });
    }

    getResults(results) {
        this.setState({ results });
        this.handlePaginationChange({}, { activePage: 1 });
    }

    getDataToRender() {
        if (this.state.results.length !== 0) {
            return this.state.results;
        }
        return this.state.students;
    }

    handlePaginationChange = (e, { activePage }) => this.setState({ activePage });

    isStudentChecked(student) {
        return this.state.selectedStudents.some(el => el.oID === student.oID);
    }

    handleStudentCheck(student) {
        const exists = this.state.selectedStudents.some(el => el.oID === student.oID);

        if (exists) {
            this.setState({
                selectedStudents: this.state.selectedStudents.filter(el => el.oID !== student.oID)
            });
        } else {
            this.setState({
                selectedStudents: [...this.state.selectedStudents, student]
            });
        }
    }

    handleSelectAllCurrent() {
        const allStudents = this.getDataToRender().filter(student => !student.transferredToEUNSA);

        const allSelected = allStudents.length > 0 && allStudents.every(student =>
            this.state.selectedStudents.some(el => el.oID === student.oID)
        );

        if (allSelected) {
            this.setState({
                selectedStudents: []
            });
        } else {
            this.setState({
                selectedStudents: [...allStudents]
            });
        }
    }

    handleSelectAllTransferred() {
        const allStudents = this.state.students || [];

        const allSelected = allStudents.length > 0 && allStudents.every(student =>
            this.isTransferredStudentChecked(student)
        );

        if (allSelected) {
            const changedTransferredStudents = allStudents
                .filter(student => student.transferredToEUNSA === true)
                .map(student => ({ ...student, transferredToEUNSA: false }));

            this.setState({
                selectedTransferredStudents: [],
                changedTransferredStudents
            });
        } else {
            const selectedTransferredStudents = [...allStudents];

            const changedTransferredStudents = allStudents
                .filter(student => student.transferredToEUNSA !== true)
                .map(student => ({ ...student, transferredToEUNSA: true }));

            this.setState({
                selectedTransferredStudents,
                changedTransferredStudents
            });
        }
    }

    isTransferredStudentChecked(student) {
        return this.state.selectedTransferredStudents.some(el => el.oID === student.oID);
    }

    toggleTransferredStudent(student) {
        const existsInSelected = this.state.selectedTransferredStudents.some(el => el.oID === student.oID);

        const newTransferredValue = !existsInSelected;

        let selectedTransferredStudents;
        if (existsInSelected) {
            selectedTransferredStudents = this.state.selectedTransferredStudents.filter(el => el.oID !== student.oID);
        } else {
            selectedTransferredStudents = [...this.state.selectedTransferredStudents, student];
        }

        let changedTransferredStudents = this.state.changedTransferredStudents.filter(el => el.oID !== student.oID);

        if (newTransferredValue !== !!student.transferredToEUNSA) {
            changedTransferredStudents = [
                ...changedTransferredStudents,
                { ...student, transferredToEUNSA: newTransferredValue }
            ];
        }

        this.setState({
            selectedTransferredStudents,
            changedTransferredStudents
        });
    }

    handleCancelTransferredEdit() {
        this.setState({
            prebacenEditMode: false,
            selectedTransferredStudents: [],
            changedTransferredStudents: []
        });
    }

    handleSaveTransferred() {
        const {
            organizationalUnitId,
            year,
            cycle,
            enrollmentCallOrdinal,
            changedTransferredStudents
        } = this.state;

        const studentsForTrue = changedTransferredStudents.filter(el => el.transferredToEUNSA === true);
        const studentsForFalse = changedTransferredStudents.filter(el => el.transferredToEUNSA === false);

        this.setState({ loading: true });

        const requests = [];

        if (studentsForTrue.length > 0) {
            requests.push(
                axios.post(
                    `/enrollments/transfer-status/${organizationalUnitId}/${year}/${cycle}/${enrollmentCallOrdinal}/true`,
                    studentsForTrue
                )
            );
        }

        if (studentsForFalse.length > 0) {
            requests.push(
                axios.post(
                    `/enrollments/transfer-status/${organizationalUnitId}/${year}/${cycle}/${enrollmentCallOrdinal}/false`,
                    studentsForFalse
                )
            );
        }

        if (requests.length === 0) {
            this.setState({
                loading: false,
                prebacenEditMode: false,
                selectedTransferredStudents: [],
                changedTransferredStudents: []
            });
            return;
        }

        axios.all(requests)
            .then(() => {
                this.setState({
                    prebacenEditMode: false,
                    selectedTransferredStudents: [],
                    changedTransferredStudents: []
                }, () => {
                    this.fetchStudents();
                });
            })
            .catch(() => {
                this.setState({
                    loading: false
                });
                toast('Došlo je do greške. Nije moguće sačuvati status prebačen.');
            });
    }

    getSelectedStudyPrograms() {
        const selectedStudents = this.state.selectedStudents || [];

        const selectedSmjerIds = [...new Set(
            selectedStudents
                .map(student => student.smjerId)
                .filter(smjerId => smjerId !== null && smjerId !== undefined)
        )];

        const rows = selectedSmjerIds.map((smjerId) => {
            const found = this.state.validatedStudyPrograms.find(sp => sp.id === smjerId);

            if (found) {
                return {
                    ...found,
                    onlineUpisSmjer: (selectedStudents.find(student => student.smjerId === smjerId) || {}).smjer || '',
                    missing: !found.valid
                };
            }

            const matchingStudent = selectedStudents.find(student => student.smjerId === smjerId);

            return {
                id: smjerId,
                name: 'Smjer nije pronađen na eUNSA sistemu.',
                studyProgramBasicName: '',
                onlineUpisSmjer: matchingStudent && matchingStudent.smjer ? matchingStudent.smjer : '',
                missing: true
            };
        });

        const existingRows = rows.filter(row => !row.missing);
        const missingRows = rows.filter(row => row.missing);

        return [...existingRows, ...missingRows];
    }

    openEnrollmentModal() {
        const studyProgramIds = [...new Set(
            this.state.selectedStudents
                .map(student => student.smjerId)
                .filter(smjerId => smjerId !== null && smjerId !== undefined)
        )];

        this.setState({ loading: true });
        axios.post(`/enrollments/validate-study-programs/${this.state.organizationalUnitId}`, studyProgramIds)
            .then(res => {
                this.setState({
                    validatedStudyPrograms: res.data || [],
                    open: true,
                    loading: false,
                    enrollFinished: false,
                    enrollmentResult: null
                });
            })
            .catch(() => {
                this.setState({ loading: false });
                toast('Nije moguće provjeriti smjerove odabranih studenata.');
            });
    }

    removeStudentsWithMissingStudyProgram() {
        const missingStudyProgramIds = this.getSelectedStudyPrograms()
            .filter(sp => sp.missing)
            .map(sp => sp.id);

        this.setState(prevState => ({
            selectedStudents: prevState.selectedStudents.filter(
                student => missingStudyProgramIds.indexOf(student.smjerId) === -1
            )
        }));
    }

    handleCloseModal() {
        this.setState({
            open: false,
            enrollFinished: false,
            enrollmentResult: null
        }, () => {
            if (this.state.searched) {
                this.fetchStudents();
            }
        });
    }

    renderStatusIcon(type, value) {
        if (type === 'ispisan') {
            return <Icon name="sign-out" color={value ? 'red' : 'grey'} />;
        }

        if (type === 'upisan') {
            return <Icon name="sign-in" color={value ? 'green' : 'grey'} />;
        }

        if (type === 'prebacen') {
            return value ? <Icon name="check" color="green" /> : null;
        }

        return null;
    }

    render() {
        const {
            loading,
            organizationalUnitId,
            orgUnits,
            academicYears,
            year,
            cycle,
            enrollmentCallOrdinal,
            searched,
            open,
            selectedStudents,
            prebacenEditMode,
            enrolling,
            enrollFinished,
            enrollmentResult
        } = this.state;

        const studyCycles = [
            { key: 1, value: 1, text: 'I ciklus, stručni i integrirani studij' },
            { key: 2, value: 2, text: 'II ciklus' },
            { key: 3, value: 3, text: 'Specijalistički studij' }
        ];

        const enrollmentCallOrdinals = [
            { key: 1, value: 1, text: 'Prvi upisni rok' },
            { key: 2, value: 2, text: 'Drugi upisni rok' }
        ];

        const indexOfLastPost = this.state.activePage * this.state.postsPerPage;
        const indexOfFirstPost = indexOfLastPost - this.state.postsPerPage;
        const currentPosts = this.getDataToRender().slice(indexOfFirstPost, indexOfLastPost);

        const allCurrentSelected = this.getDataToRender().filter(student => !student.transferredToEUNSA).length > 0
            && this.getDataToRender().filter(student => !student.transferredToEUNSA).every(student =>
                selectedStudents.some(el => el.oID === student.oID)
            );

        const selectedStudyPrograms = this.getSelectedStudyPrograms();
        const hasMissingStudyPrograms = selectedStudyPrograms.some(sp => sp.missing);
        const canEnrollStudents = selectedStudents.length > 0 && !hasMissingStudyPrograms;

        const allTransferredSelected = this.state.students.length > 0 && this.state.students.every(student =>
            this.isTransferredStudentChecked(student)
        );

        return (
            <div>
                <Modal
                    open={open}
                    onClose={() => {
                        if (!enrolling) {
                            this.handleCloseModal();
                        }
                    }}
                    center
                    blockScroll={false}
                    styles={{
                        overlay: { background: 'transparent' },
                        modal: {
                            width: '1100px',
                            maxWidth: '95%',
                            maxHeight: '90vh',
                            padding: '24px'
                        }
                    }}
                    closeOnEsc={!enrolling}
                    closeOnOverlayClick={!enrolling}
                >
                    <div style={{ maxHeight: '75vh', overflowY: 'auto', overflowX: 'hidden' }}>
                        <br />
                        <h2>Prebacivanje brucoša sa sistema <i>Online upis</i> na <i>eUNSA sistem</i></h2>
                        <Divider />

                        {enrolling ? (
                            <div style={{ paddingTop: '220px', paddingBottom: '220px' }}>
                                <Loader active inline="centered" />
                            </div>
                        ) : enrollFinished ? (
                            <div>
                                {enrollmentResult && (enrollmentResult.success > 0 || enrollmentResult.failed > 0) && (
                                    <div
                                        style={{
                                            display: 'grid',
                                            gridTemplateColumns: enrollmentResult.success > 0 && enrollmentResult.failed > 0 ? '1fr 1fr' : '1fr',
                                            gap: '16px',
                                            marginBottom: '16px',
                                            alignItems: 'stretch'
                                        }}
                                    >
                                        {enrollmentResult.success > 0 && (
                                            <Message positive style={{ margin: 0, height: '100%' }}>
                                                <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                                                    <Icon name="check circle" color="green" size="big" />
                                                    <div>
                                                        <div style={{ fontSize: '18px', fontWeight: 'bold' }}>
                                                            {enrollmentResult.success}/{enrollmentResult.total} brucoša uspješno prebačeno
                                                        </div>

                                                        Ukupno brucoša: <b>{enrollmentResult.total}</b>
                                                        <br/>
                                                        Uspješno prebačnih: <b> {enrollmentResult.success}</b>
                                                        <br/>
                                                    </div>
                                                </div>
                                            </Message>
                                        )}

                                        {enrollmentResult.failed > 0 && (
                                            <Message negative style={{ margin: 0, height: '100%' }}>
                                                <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                                                    <Icon name="times circle" color="red" size="big" />
                                                    <div>
                                                        <div style={{ fontSize: '18px', fontWeight: 'bold' }}>
                                                            {enrollmentResult.failed}/{enrollmentResult.total} brucoša neuspješno prebačeno
                                                        </div>
                                                        Ukupno brucoša: <b>{enrollmentResult.total}</b>
                                                        <br/>
                                                        Neuspješno prebačnih: <b> {enrollmentResult.failed}</b>
                                                        <br/>
                                                    </div>
                                                </div>
                                            </Message>
                                        )}
                                    </div>
                                )}

                                {enrollmentResult && enrollmentResult.failed > 0 && (
                                    <div>
                                        <div>
                                            <Message>
                                                Ukoliko ima brucoša čije prebacivanje nije uspješno izvršeno, isti će biti prikazani u tabeli ispod. U koloni <i>Greška</i> naveden je razlog neuspješnog prebacivanja.
                                                Nakon pregleda, klikom na dugme <i>Zatvori</i>, zatvarate trenutni prikaz te se vraćate na početnu tabelu gdje možete pregledati statuse prebacivanja svih studenata.
                                            </Message>
                                            <div
                                                style={{
                                                    maxHeight: '400px',
                                                    overflowY: 'auto',
                                                    overflowX: 'hidden',
                                                    paddingRight: '12px',
                                                    boxSizing: 'content-box'
                                                }}
                                            >
                                                <Table celled unstackable compact style={{ width: '100%' }}>
                                                    <Table.Header>
                                                        <Table.Row>
                                                            <Table.HeaderCell>JMBG</Table.HeaderCell>
                                                            <Table.HeaderCell>Ime</Table.HeaderCell>
                                                            <Table.HeaderCell>Prezime</Table.HeaderCell>
                                                            <Table.HeaderCell>Smjer ID</Table.HeaderCell>
                                                            <Table.HeaderCell>Greška</Table.HeaderCell>
                                                        </Table.Row>
                                                    </Table.Header>
                                                    <Table.Body>
                                                        {enrollmentResult.failedStudents.map((row, index) => {
                                                            const jmbgMatch = row.match(/JMBG:\s*([^|]+)/);
                                                            const imeMatch = row.match(/Ime:\s*([^|]+)/);
                                                            const prezimeMatch = row.match(/Prezime:\s*([^|]+)/);
                                                            const smjerIdMatch = row.match(/SmjerId:\s*([^|]+)/);
                                                            const errorMatch = row.match(/ERROR:\s*(.*)$/);

                                                            return (
                                                                <Table.Row key={index} negative>
                                                                    <Table.Cell>{jmbgMatch ? jmbgMatch[1].trim() : ''}</Table.Cell>
                                                                    <Table.Cell>{imeMatch ? imeMatch[1].trim() : ''}</Table.Cell>
                                                                    <Table.Cell>{prezimeMatch ? prezimeMatch[1].trim() : ''}</Table.Cell>
                                                                    <Table.Cell>{smjerIdMatch ? smjerIdMatch[1].trim() : ''}</Table.Cell>
                                                                    <Table.Cell>{errorMatch ? errorMatch[1].trim() : row}</Table.Cell>
                                                                </Table.Row>
                                                            );
                                                        })}
                                                    </Table.Body>
                                                </Table>
                                            </div>
                                        </div>
                                    </div>
                                )}

                                {enrollmentResult && enrollmentResult.success === 0 && enrollmentResult.failed === 0 && (
                                    <Message>Nemate podataka za prikaz.</Message>
                                )}

                                <br />
                                <Button
                                    floated="right"
                                    color="blue"
                                    onClick={this.handleCloseModal}
                                >
                                    Zatvori
                                </Button>
                            </div>
                        ) : (
                            <div>
                                <Message>
                                    Od ukupnog broja studenata <b>{this.state.students.length}</b>, označeno je <b>{selectedStudents.length}</b> za prebacivanje.
                                    <br />
                                    U tabeli ispod prikazani su smjerovi na koje se upisuju odabrani studenti.
                                    Crveno označeni redovi ukazuju na nepostojeće ili pasivne smjerove te smjerove koji pripadaju drugoj organizacionoj jedinici.
                                    Takve studente moguće je izostaviti iz trenutnog procesa upisa klikom na crveno dugme u tabeli.
                                    Nakon izostavljanja oni više neće biti označeni u početnoj tabeli, a njihov upis će se moći naknadno izvršiti, nakon provjere sa podrškom <i>eUNSA sistema</i>.
                                </Message>

                                <div style={{ maxHeight: '400px', overflowY: 'auto', overflowX: 'auto' }}>
                                    <h2>Prikaz podudarnosti smjerovima sa sistema <i>Online upis</i> i <i>eUNSA</i></h2>
                                    <Table celled unstackable compact>
                                        <Table.Header>
                                            <Table.Row>
                                                <Table.HeaderCell>ID (smjer ID)</Table.HeaderCell>
                                                <Table.HeaderCell>Smjer (Online upis)</Table.HeaderCell>
                                                <Table.HeaderCell>Smjer (eUNSA)</Table.HeaderCell>
                                                <Table.HeaderCell>Nastavni plan i program</Table.HeaderCell>
                                                <Table.HeaderCell>Status</Table.HeaderCell>
                                                <Table.HeaderCell>Komentar</Table.HeaderCell>
                                            </Table.Row>
                                        </Table.Header>
                                        <Table.Body>
                                            {selectedStudyPrograms.length > 0 ? selectedStudyPrograms.map((sp) => (
                                                <Table.Row key={sp.id} negative={sp.missing}>
                                                    <Table.Cell>{sp.id}</Table.Cell>
                                                    <Table.Cell>{sp.onlineUpisSmjer}</Table.Cell>
                                                    <Table.Cell>{sp.studyProgramBasicName}</Table.Cell>
                                                    <Table.Cell>{sp.name}</Table.Cell>
                                                    <Table.Cell>{sp.status || '-'}</Table.Cell>
                                                    <Table.Cell>{sp.comment}</Table.Cell>
                                                </Table.Row>
                                            )) : (
                                                <Table.Row>
                                                    <Table.Cell colSpan={6}>Nema podataka za prikaz.</Table.Cell>
                                                </Table.Row>
                                            )}
                                        </Table.Body>
                                    </Table>
                                </div>

                                {selectedStudyPrograms.some(sp => sp.missing) && (
                                    <div style={{ color: '#9f3a38', marginBottom: '10px', marginTop: '10px' }}>
                                        Crveno označeni redovi predstavljaju smjerove na koje nije dozvoljen upis. Tačan razlog prikazan je u koloni <i>Komentar</i>.
                                    </div>
                                )}

                                <br/>
                                <Button floated="right" color="blue" basic="true" onClick={this.handleCloseModal}>
                                    Odustani
                                </Button>

                                {hasMissingStudyPrograms ? (
                                    <Button floated="right" color="red" onClick={this.removeStudentsWithMissingStudyProgram}>
                                        Izostavi studente sa neodgovarajućim smjer ID-jem
                                    </Button>
                                ) : (
                                    <Button floated="right" color="blue" onClick={this.enrollStudents} disabled={!canEnrollStudents}>
                                        Upiši brucoše
                                    </Button>
                                )}
                            </div>
                        )}
                    </div>
                </Modal>

                <Header as="h1">Online upis</Header>

                <Segment.Group raised>
                    <Segment raised>
                        <Header as="h3">
                            Prebacivanje studenata sa sistema <i>Online upis</i> na <i>eUNSA sistem</i>
                        </Header>
                    </Segment>

                    <Segment>
                        <Form>
                            <Form.Group widths="equal">
                                <Form.Field>
                                    <label>Organizaciona jedinica</label>
                                    <Form.Dropdown
                                        clearable
                                        placeholder="Odaberite organizacionu jedinicu"
                                        value={organizationalUnitId}
                                        onChange={this.handleInputChange}
                                        name="organizationalUnitId"
                                        options={orgUnits}
                                        search
                                        fluid
                                        selection
                                    />
                                </Form.Field>

                                <Form.Field>
                                    <label>Akademska godina</label>
                                    <Form.Dropdown
                                        clearable
                                        placeholder="Odaberite akademsku godinu"
                                        value={year}
                                        onChange={this.handleInputChange}
                                        name="year"
                                        options={academicYears}
                                        search
                                        fluid
                                        selection
                                    />
                                </Form.Field>
                            </Form.Group>

                            <Form.Group widths="equal">
                                <Form.Field>
                                    <label>Ciklus</label>
                                    <Form.Dropdown
                                        clearable
                                        placeholder="Odaberite ciklus"
                                        value={cycle}
                                        onChange={this.handleInputChange}
                                        name="cycle"
                                        options={studyCycles}
                                        fluid
                                        selection
                                    />
                                </Form.Field>

                                <Form.Field>
                                    <label>Upisni rok</label>
                                    <Form.Dropdown
                                        clearable
                                        placeholder="Odaberite upisni rok"
                                        value={enrollmentCallOrdinal}
                                        onChange={this.handleInputChange}
                                        name="enrollmentCallOrdinal"
                                        options={enrollmentCallOrdinals}
                                        fluid
                                        selection
                                    />
                                </Form.Field>
                            </Form.Group>

                            <Form.Field style={{ textAlign: 'right', marginTop: '10px' }}>
                                <Button
                                    color="blue"
                                    icon
                                    labelPosition="left"
                                    onClick={this.handleSearchClick}
                                >
                                    <Icon name="search" />
                                    Prikaži brucoše
                                </Button>
                            </Form.Field>
                        </Form>
                    </Segment>

                    {searched && (
                        <Segment>
                            {
                                loading ? (
                                    <div style={{ paddingTop: '100px', paddingBottom: '100px' }}>
                                        <Loader active inline="centered" />
                                    </div>
                                ) : (
                                    <div>
                                        <Message>
                                            Tabela ispod prikazuje podatke iz baze podataka sistema <i>Online upis</i>.
                                            U prvoj koloni možete označiti brucoše za prenos na <i>eUNSA sistem</i>, a klikom na dugme <b>Upiši brucoše</b> otvara se pregled odabranih smjerova i potvrda prenosa.
                                            <div style={{
                                                marginTop: '12px',
                                                padding: '10px',
                                                borderLeft: '4px solid #db2828',
                                                backgroundColor: '#fff6f6'
                                            }}>
                                                <Icon name="sign-out" color="red" />
                                                <b>Napomena za ispisane studente:</b> Ako je student u tabeli označen kao ispisan,
                                                nakon prenosa na <i>eUNSA sistem</i> potrebno ga je prvo upisati u odgovarajući semestar,
                                                a zatim evidentirati ispis sa studijskog programa.
                                            </div>
                                        </Message>

                                        {this.state.students.length > 0 ? (
                                            <div>
                                                <Table selectable celled compact verticalAlign="middle">
                                                    <Table.Header>
                                                        <Table.HeaderCell colSpan={prebacenEditMode ? 26 : 27}>
                                                            <SearchTableData
                                                                profMozilla
                                                                data={this.state.students}
                                                                getResults={this.getResults}
                                                                filterItem={[
                                                                    'ime',
                                                                    'prezime',
                                                                    'jmbg',
                                                                    'brojIndeksa',
                                                                    'oID',
                                                                    'smjer',
                                                                    'odsjek',
                                                                    'smjerId'
                                                                ]}
                                                            />
                                                        </Table.HeaderCell>
                                                        <Table.Row>
                                                            {!prebacenEditMode && (
                                                                <Table.HeaderCell verticalAlign="middle" colSpan={1} width="1" textAlign="center">
                                                                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                                                        <Checkbox
                                                                            checked={allCurrentSelected}
                                                                            onChange={this.handleSelectAllCurrent}
                                                                        />
                                                                        <span style={{ marginTop: '4px', fontSize: '12px' }}>Sve</span>
                                                                    </div>
                                                                </Table.HeaderCell>
                                                            )}
                                                            <Table.HeaderCell verticalAlign="middle" colSpan={3}>Ime i prezime</Table.HeaderCell>
                                                            <Table.HeaderCell verticalAlign="middle" colSpan={3}>JMBG</Table.HeaderCell>
                                                            <Table.HeaderCell verticalAlign="middle" colSpan={3}>oID</Table.HeaderCell>
                                                            <Table.HeaderCell verticalAlign="middle" colSpan={3}>Broj indexa</Table.HeaderCell>
                                                            <Table.HeaderCell verticalAlign="middle" colSpan={3}>Odsjek</Table.HeaderCell>
                                                            <Table.HeaderCell verticalAlign="middle" colSpan={3}>Smjer</Table.HeaderCell>
                                                            <Table.HeaderCell verticalAlign="middle" colSpan={2}>Smjer ID</Table.HeaderCell>
                                                            <Table.HeaderCell verticalAlign="middle" colSpan={2} textAlign="center">Ispisan</Table.HeaderCell>
                                                            <Table.HeaderCell verticalAlign="middle" colSpan={2} textAlign="center">Upisan</Table.HeaderCell>
                                                            <Table.HeaderCell verticalAlign="middle" colSpan={2} textAlign="center">
                                                                {!prebacenEditMode ? (
                                                                    <div style={{ position: 'relative', width: '100%', textAlign: 'center' }}>
                                                                        <span>Prebačen</span>
                                                                        <div style={{ position: 'absolute', right: 0, top: '50%', transform: 'translateY(-50%)' }}>
                                                                            <Popup
                                                                                content="Uredi status prebačen"
                                                                                position="top center"
                                                                                trigger={
                                                                                    <Icon
                                                                                        circular
                                                                                        name="pencil"
                                                                                        color="green"
                                                                                        link
                                                                                        onClick={() => this.setState({
                                                                                            prebacenEditMode: true,
                                                                                            selectedTransferredStudents: this.state.students.filter(student => student.transferredToEUNSA === true),
                                                                                            changedTransferredStudents: []
                                                                                        })}
                                                                                    />
                                                                                }
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                ) : (
                                                                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}>
                                                                        <Popup
                                                                            content="Sačuvaj"
                                                                            position="top center"
                                                                            trigger={
                                                                                <Button
                                                                                    basic
                                                                                    circular
                                                                                    icon
                                                                                    size="mini"
                                                                                    color="blue"
                                                                                    onClick={this.handleSaveTransferred}
                                                                                >
                                                                                    <Icon name="check" />
                                                                                </Button>
                                                                            }
                                                                        />
                                                                        <Popup
                                                                            content="Odustani"
                                                                            position="top center"
                                                                            trigger={
                                                                                <Button
                                                                                    basic
                                                                                    circular
                                                                                    icon
                                                                                    size="mini"
                                                                                    color="red"
                                                                                    onClick={this.handleCancelTransferredEdit}
                                                                                >
                                                                                    <Icon name="close" />
                                                                                </Button>
                                                                            }
                                                                        />
                                                                    </div>
                                                                )}
                                                            </Table.HeaderCell>
                                                        </Table.Row>
                                                    </Table.Header>

                                                    <Table.Body>
                                                        {prebacenEditMode && (
                                                            <Table.Row>
                                                                <Table.Cell colSpan={24} />
                                                                <Table.Cell verticalAlign="middle" colSpan={2} textAlign="center">
                                                                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                                                        <Checkbox
                                                                            checked={allTransferredSelected}
                                                                            onChange={this.handleSelectAllTransferred}
                                                                        />
                                                                        <span style={{ marginTop: '4px', fontSize: '12px' }}>Sve</span>
                                                                    </div>
                                                                </Table.Cell>
                                                            </Table.Row>
                                                        )}
                                                        {
                                                            currentPosts && currentPosts.length > 0 ? currentPosts.map((student, index) => (
                                                                <Table.Row
                                                                    key={index}
                                                                    positive={student.transferredToEUNSA === true}
                                                                    onClick={!prebacenEditMode && !student.transferredToEUNSA ? () => this.handleStudentCheck(student) : undefined}
                                                                    className={!prebacenEditMode && this.isStudentChecked(student) ? 'table-active' : ''}
                                                                    style={{ cursor: prebacenEditMode || student.transferredToEUNSA ? 'default' : 'pointer' }}
                                                                >
                                                                    {!prebacenEditMode && (
                                                                        <Table.Cell width="1" textAlign="center">
                                                                            <Checkbox
                                                                                name={student.oID}
                                                                                type="checkbox"
                                                                                checked={this.state.selectedStudents.findIndex(el => el.oID === student.oID) > -1}
                                                                                disabled={student.transferredToEUNSA === true}
                                                                            />
                                                                        </Table.Cell>
                                                                    )}
                                                                    <Table.Cell verticalAlign="middle" colSpan={3}>
                                                                        {index + 1 + ((this.state.activePage - 1) * this.state.postsPerPage)}. {student.fullName || (((student.ime || '') + ' ' + (student.prezime || '')).trim())}
                                                                    </Table.Cell>
                                                                    <Table.Cell verticalAlign="middle" colSpan={3}>{student.jmbg}</Table.Cell>
                                                                    <Table.Cell verticalAlign="middle" colSpan={3}>{student.oID}</Table.Cell>
                                                                    <Table.Cell verticalAlign="middle" colSpan={3}>{student.brojIndeksa}</Table.Cell>
                                                                    <Table.Cell verticalAlign="middle" colSpan={3}>{student.odsjek}</Table.Cell>
                                                                    <Table.Cell verticalAlign="middle" colSpan={3}>{student.smjer}</Table.Cell>
                                                                    <Table.Cell verticalAlign="middle" colSpan={2}>{student.smjerId}</Table.Cell>
                                                                    <Table.Cell verticalAlign="middle" colSpan={2} textAlign="center">
                                                                        {this.renderStatusIcon('ispisan', student.naknadnoIspisan)}
                                                                    </Table.Cell>
                                                                    <Table.Cell verticalAlign="middle" colSpan={2} textAlign="center">
                                                                        {this.renderStatusIcon('upisan', student.upisan)}
                                                                    </Table.Cell>
                                                                    <Table.Cell
                                                                        verticalAlign="middle"
                                                                        colSpan={2}
                                                                        textAlign="center"
                                                                        onClick={prebacenEditMode ? (e) => e.stopPropagation() : undefined}
                                                                    >
                                                                        {prebacenEditMode ? (
                                                                            <Checkbox
                                                                                checked={this.isTransferredStudentChecked(student)}
                                                                                onChange={() => this.toggleTransferredStudent(student)}
                                                                            />
                                                                        ) : (
                                                                            this.renderStatusIcon('prebacen', student.transferredToEUNSA)
                                                                        )}
                                                                    </Table.Cell>
                                                                </Table.Row>
                                                            )) : (
                                                                <Table.Row>
                                                                    <Table.Cell colSpan={prebacenEditMode ? 26 : 27} textAlign="left">
                                                                        Nema podataka za prikaz.
                                                                    </Table.Cell>
                                                                </Table.Row>
                                                            )
                                                        }
                                                    </Table.Body>
                                                </Table>

                                                <div style={{ marginTop: '15px', textAlign: 'right' }}>
                                                    <Button
                                                        color="blue"
                                                        icon
                                                        labelPosition="left"
                                                        disabled={selectedStudents.length === 0}
                                                        onClick={this.openEnrollmentModal}
                                                    >
                                                        <Icon name="sign-in" />
                                                        Upiši brucoše
                                                    </Button>
                                                </div>
                                            </div>
                                        ) : (
                                            <div>Nema podataka za prikaz.</div>
                                        )}
                                    </div>
                                )
                            }

                            {currentPosts.length > 0 && !loading && (
                                <PaginationFront
                                    postsPerPage={this.state.postsPerPage}
                                    totalPosts={this.getDataToRender().length}
                                    paginate={this.handlePaginationChange}
                                    activePage={this.state.activePage}
                                />
                            )}
                        </Segment>
                    )}
                </Segment.Group>

                <ToastContainer hideProgressBar position="top-right" />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/Admin/OnlineEnrollment/OnlineEnrollment.js